import { valueof } from 'interfaces'
import { InsightId } from 'interfaces/insights'
import { PostUid } from 'interfaces/feed'

export const INSIGHT_EVENT_CATEGORY = 'insight' as const
export const IMPERSONALIZED_INSIGHT_EVENT_CATEGORY = 'impersonalized_insight' as const
export const POST_IMPRESSION_CATEGORY = 'post_impression_category' as const

export type InsightEventName =
  | 'shown'
  | 'dismiss'
  | 'undismiss'
  | 'edit'
  | 'link'
  | 'offer'
  | 'set_tracker'
  | 'edit_tracker'
  | 'update_credentials'
  | 'add_account'
  | 'add_home'
  | 'add_car'
  | 'link_creditfile'
  | 'view_post'
  | 'view_comment'
  | 'allow_push_notifications'
  | 'popup'
  | 'meeting_info'

export type InsightEventData = {
  insight_id: InsightId
}

export type InsightEvent = {
  name: InsightEventName
  data: InsightEventData
}

type PostImpressionEvent = {
  uid: PostUid
}

export type EventsMap = {
  [INSIGHT_EVENT_CATEGORY]: InsightEvent
  [IMPERSONALIZED_INSIGHT_EVENT_CATEGORY]: InsightEvent
  [POST_IMPRESSION_CATEGORY]: PostImpressionEvent
}

export type Event = valueof<EventsMap>

export type EventCategory = keyof EventsMap

export type PlainEvent = {
  name: string
  data: InsightEventData
}

export type PostImpressionsArray = {
  viewed_posts_uids: PostUid[]
}
